import { Component, ChangeDetectionStrategy } from "@angular/core";

@Component({
  standalone: false,
  selector: "app-proficiency-legend-dialog",
  templateUrl: "./proficiency-legend-dialog.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./proficiency-legend-dialog.component.css"],
})
export class ProficiencyLegendDialogComponent {}
